import { selfAxios } from "../../../../../../axios/selfAxios.js";
async function reqGetUserMenuListByUserId(params) {
  const {
    data: { data }
  } = await selfAxios.get("/ucenterapi/uc/internal/common/getUserMenuListByUserId", {
    params,
    _cache: true
  });
  return data;
}
export { reqGetUserMenuListByUserId };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/request/ucenterapi/uc/internal/common/getUserMenuListByUserId/get.js